import React, { useCallback, FC, useEffect, useRef } from 'react';
import { LocalParticipant, LocalTrack, RemoteParticipant, RemoteTrack, RoomEvent, Track } from 'livekit-client';

import css from './Room.module.scss';

type Props = {
  participant: LocalParticipant | RemoteParticipant;
};

const Participant: FC<Props> = ({ participant }) => {
  const mediaEl = useRef<HTMLAudioElement>(null);

  const attachTrack = useCallback((track: RemoteTrack | LocalTrack /*publication: RemoteTrackPublication*/) => {
    if (mediaEl.current && !participant.isLocal) {
      track.attach(mediaEl.current);
    }
  }, []);

  const detachTrack = useCallback((track: RemoteTrack | LocalTrack /*publication: RemoteTrackPublication*/) => {
    if (mediaEl.current) track.detach(mediaEl.current);
  }, []);

  useEffect(() => {
    if (!mediaEl.current) return;

    const pub = participant.getTrack(Track.Source.Microphone);

    if (pub?.track && !participant.isLocal) {
      attachTrack(pub.track /*pub as RemoteTrackPublication*/);
    }

    participant.on(RoomEvent.TrackSubscribed, attachTrack);
    participant.on(RoomEvent.TrackUnsubscribed, detachTrack);

    return () => {
      participant.off(RoomEvent.TrackSubscribed, attachTrack);
      participant.off(RoomEvent.TrackUnsubscribed, detachTrack);
    };
  }, [participant, attachTrack, detachTrack]);

  return (
    <div className={css.participant}>
      <audio controls ref={mediaEl} autoPlay />
    </div>
  );
};

export default Participant;
